import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const ProfilesCreatedMonthToDate = () => {
  const { profilesCreated, profilesCreatedRawDataLink, profilesCreatedChange } = useSelector(
    (state) => state.leadsAdded.leads
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay
        value={profilesCreated}
        url={profilesCreatedRawDataLink}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={profilesCreatedChange}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </>
  );
};

export default ProfilesCreatedMonthToDate;
